import { render, staticRenderFns } from "./ConceptListing.vue?vue&type=template&id=5a28290c"
import script from "./ConceptListing.vue?vue&type=script&lang=ts"
export * from "./ConceptListing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports